export class LlmClientRateLimits {
  public requestsPerMinute?: number | null;
  public tokensPerMinute?: number | null;
  public tokenPerDay?: number | null;

  constructor(data: any = {}) {
    this.requestsPerMinute = data.requestsPerMinute || null;
    this.tokensPerMinute = data.tokensPerMinute || null;
    this.tokenPerDay = data.tokenPerDay || null;
  }
}
